<script lang="ts" setup>
  import type { User } from '@solfacil/girassol/dist/types/components/headers/types';

  defineProps<{
    user: User;
  }>();

  defineEmits<{ (event: 'close'): void }>();
</script>

<template>
  <div class="store-user-info-menu-action">
    <div class="info-content">
      <icon-girassol:account-circle class="icon" />
      <div class="info">
        <span class="title">Boas-vindas</span>
        <span class="subtitle">{{ user.completeName }}</span>
      </div>
    </div>
    <div class="close-button" @click="$emit('close')">
      <icon-girassol:close class="close" />
    </div>
  </div>
</template>

<style lang="scss">
  .store-user-info-menu-action {
    @apply flex items-center justify-between gap-nano;
    @apply py-4xs pl-2xs pr-micro;

    > .info-content {
      @apply flex items-center gap-nano;

      > .icon {
        @apply icon-size-large;
        @apply text-neutral-low-dark;
      }

      > .info {
        @apply flex flex-col items-start;

        > .title {
          @apply fonts-body-small-regular;
          @apply text-neutral-low-light;
        }

        > .subtitle {
          @apply fonts-body-large-bold;
          @apply text-neutral-low-dark;
        }
      }
    }

    > .close-button {
      @apply flex items-center justify-center;
      @apply w-md h-md;
      @apply cursor-pointer;

      > .close {
        @apply icon-size-medium;
      }
    }
  }
</style>
